import { Planzone, planzone } from "./planzone";
import { UserAccount, userAccount } from "./userAccount";
import { Id, id } from "./id";
import { Preferences, preferences } from "./preferences";
import { Resource, resource } from "./resource";
import { Identifiable } from "./identifiable";

type Account = {
  uuid: Id;
  lastName: string;
  firstName: string;
  email: string;
  planzone: Planzone;
  planzoneUuid: Id;
  userAccount: UserAccount;
  preferences: Preferences;
  resource: Identifiable<Resource>;
  token: string;
};

const account: Account = {
  uuid: id,
  lastName: "",
  firstName: "",
  email: "",
  planzoneUuid: "",
  planzone,
  userAccount,
  preferences,
  resource: { ...resource, uuid: "" },
  token: "",
};

export type { Account };

export { account };
